import genericMemo from "Common/componentUtils/genericMemo";
import { withTooltip } from "Components/withPopover";
import React from "react";
import Button from "./button";
const ButtonWithTooltip = withTooltip(({ id, wrapperClassName, ...other }) => (React.createElement("div", { id: id, className: wrapperClassName },
    React.createElement(Button, { ...other }))));
export default genericMemo(ButtonWithTooltip);
